import React, { useRef, useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import Footer from "../../components/Footer/Footer";
import ReactFullpage from "@fullpage/react-fullpage";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import './home.less';
import 'swiper/css';
import 'swiper/css/pagination';

import { Pagination, Navigation } from 'swiper/modules';

function Home({ setHeaderDark }) {
  const navigate = useNavigate();
  const [hovered, setHovered] = useState(false)
  const [leftBtnHovered, setLeftBtnHovered] = useState(false)
  const [rightBtnHovered, setRightBtnHovered] = useState(false)

  // 穿戴产品
  const WearableList = [
    {
      title: 'ARTA 埃尔塔®',
      // subTitle: '全年龄弱视治疗仪',
      subTitle: '视觉功能训练治疗软件',
      img: '/images/home/arta-img.png',
      miniImg: '/images/home/mini-img-arta.png',
      route: '/arta',
    },
    {
      title: 'ARGOS 爱格视™',
      subTitle: '全功能3D近视训练仪',
      img: '/images/home/argos-img.png',
      miniImg: '/images/home/mini-img-argos.png',
      route: '/argos',
    },
    {
      title: 'EYEPAL 眼派™',
      subTitle: '可视温润舒眼仪',
      img: '/images/home/eyepal-img.png',
      miniImg: '/images/home/mini-img-eyepal.png',
      route: '/eyepal',
    }
  ]
  // 在研方案
  const TreatmentPlanList = [
    {
      title: '创新青光眼治疗方案',
      desc: '集视医疗正在开发一种青光眼治疗设备，无需手术和药物治疗即可修复青光眼患者的缺损视野。',
      img: '/images/home/qingguanplan.jpg',
      route: '/glaucoma'
    },
    {
      title: '斜视术后康复数字疗法',
      desc: '集视医疗正在开发一种斜视全周期管理方案，涵盖长期的眼动追踪、15度以内的斜视手术...',
      img: '/images/home/numberplan.jpg',
      route: '/strabismus'
    },
  ]
  // 公司动态
  const NewsList = [
    {
      title: '深耕临床前沿，聚力视康革新｜集视双城眼科学术盛会完美落幕',
      desc: '6月4日-7日，集视医疗双线奔赴宁波VDT学术交流会、沈阳非公医疗眼科年会双城行业盛会。以学术交流为核心，以技术展示为载体，与全国眼科同仁共探全龄弱视诊疗新方向，共启视光康复行业新机遇。至此，集视双城学术之旅圆满收官！',
      date: '2026/06/07',
      route: '/newsInfo/twoCitiesAcademic'
    },
    {
      title: 'Cell Reports重磅：首次揭示成人弱视神经学病理机制，首创全龄优效弱视诊疗方案',
      desc: '北京时间 2021 年 12 月 14 日，国际顶级学术期刊《Cell Reports》在线发表了由复旦大学附属眼耳鼻喉科医院文雯团队和中科院生物物理所张朋团队领衔的研究成果《成人人类弱视中膝状 - 纹状与皮质 - 顶盖通路的层选择性信号缺失与增强》。该研究联合 3T 和 7T 超高分辨率 BOLD fMRI 技术，结合精心设计的大细胞（M）/ 小细胞（P）通路特异性视觉刺激，对 17 名单侧弱视成人患者和 17 名正常对照者进行了对照研究，取得了里程碑式的发现',
      date: '2026/06',
      route: '/newsInfo/cellReportsAmblyopia'
    },
    {
      title: '出圈2026VC！｜集视医疗发布“全龄弱视诊疗黑科技”：基于脑科学机制，突破年龄限制',
      desc: '津门聚智，睛启新篇！备受行业瞩目的2026视觉健康创新发展国际会议（Vision China 2026）近日在天津圆满落幕。',
      date: '2026/06',
      route: '/newsInfo/jishiAllAgeAmblyopia'
    },
  ]
  // FCST研究院
  const FcstList = [
    {
      title: '理论突破 - 弱视的皮层下受损',
      desc: '弱视患者的一个重要临床表现在于弱视眼对空间细节的敏感度降低，包括视锐度（眼睛辨别最小视角的能力）降低；对比度敏感度，尤其是对高空间频率（细密纹理）的对比度敏感度降低。...',
      date: '2024-10-31',
      img: '/images/home/news2.png',
      route: '/fcst/breakthroughTheory',
    },
    {
      title: '方法突破 - 结合增强现实的，可以针对弱视眼P通路进行矫正的双眼图像算法',
      desc: 'Xu等人在2010年证明了通过使用推拉（Push-pull）方法来减少眼优势（sensory eye dominance）的可能性。在训练过程中（图 C），受试者的任务是辨别非优势眼看到中的光栅朝向。 刺激首先向受试者的非优势眼呈现一个矩形框（注意提示），然后分别向双眼呈现一对正交光栅。...',
      date: '2024-10-31',
      img: '/images/home/news1.png',
      route: '/fcst/breakthroughMethod',
    },
    // {
    //   title: '什么是弱视？',
    //   desc: '弱视是一种视觉发育相关疾病，其特征为戴镜视力达不到同龄儿童正常视力下线或者两眼视力相差2行以上，且经眼科检查并未发现能够引起视力差的器质性病变。...',
    //   date: '2024-10-11',
    //   img: '/images/home/news3.png',
    //   route: '/fcst/identifyAmblyopia',
    // },
    // {
    //   title: '近视防控应该怎么做?',
    //   desc: <>
    //     首先判断是真性近视还是假性近视。<br />
    //     如果孩子出现"假性近视”，可以让孩子眼睛彻底放松，使眼睛慢慢恢复…
    //   </>,
    //   date: '2024-10-11',
    //   img: '/images/home/news4.png',
    //   route: '/fcst/identifyMyopia',
    // },
  ]
  // 团队列表
  const teamList = [
    {
      name: '病理机制研究团队',
      member: ['中科院', '香港大学', '清华大学'],
      desc: '与中科院、香港大学、清华大学等顶尖机构强强联合，基于高分辨率fMRI利用功能磁共振从脑科学角度探究眼病病理机制，发现了眼病根本性损伤位点。',
      icon: '/images/home/teams1_icon_black.png',
    },
    {
      name: '临床试验团队',
      member: ['复旦眼科', '中山眼科', '温州眼视光医院'],
      // desc: <>
      //   与复旦眼科、中山眼科、温州眼视光医院等国内头部眼科专家深度合作，打造真正符合临床患者真实需求的产品。<br />
      //   产品已进行60+预临床，临床效果得到了充分验证。
      // </>,
      desc: <>
        与复旦眼科、中山眼科、温州眼视光医院等国内头部眼科专家深度合作，打造真正符合临床患者真实需求的产品。
      </>,
      icon: '/images/home/teams2_icon_black.png',
    },
    {
      name: '产品开发及注册团队',
      member: ['AI', '可穿戴设备', '....'],
      desc: <>
        将创新病理机制研究成果与AI、可穿戴设备深度整合。<br />
        通过脑区损伤位点重塑打造效果更强、依从性更强、可及性更强的创新治疗范式。
      </>,
      icon: '/images/home/teams3_icon_black.png',
    },
  ]
  // 合作列表
  const cooperate = [
    '/images/home/dx-logo/fddx.png',
    '/images/home/dx-logo/zky.png',
    '/images/home/dx-logo/zsdxyk.png',
    '/images/home/dx-logo/wzykdx.png',
    '/images/home/dx-logo/hkus.png',
    '/images/home/dx-logo/qhdx.png',
    '/images/home/dx-logo/zjdx.png',
    '/images/home/dx-logo/zsdx.png',
  ]

  const [isHomeWearablePageActive, setIsHomeWearablePageActive] = useState(false);
  const [isHomePlanPageActive, setIsHomePlanPageActive] = useState(false);
  const [isHomeNewsPageActive, setIsHomeNewsPageActive] = useState(false);
  const [isHomeFcstPageActive, setIsHomeFcstPageActive] = useState(false);
  const [isHomeAboutPageActive, setIsHomeAboutPageActive] = useState(false);

  // 穿戴产品-图片切换
  const [currentIndex, setCurrentIndex] = useState(0); // 当前图片index
  const [nextIndex, setNextIndex] = useState(0); //下一张图片index
  const [isAnimating, setIsAnimating] = useState(false); // 控制动画状态
  const [isSwitching, setIsSwitching] = useState(false);  //是否点击切换动画
  const goToPrev = () => {
    if (isAnimating) return;
    setIsSwitching(true)
    setIsAnimating(true);
    // 设置下一张图片
    setNextIndex((prev) => (prev === 0 ? WearableList.length - 1 : prev - 1))
    // 等待1s后动画结束
    setTimeout(() => {
      setIsAnimating(false);
    }, 1000); // 动画时间 1s
    // 动画结束之前设置当前图片
    setTimeout(() => {
      setCurrentIndex((prev) => (prev === 0 ? WearableList.length - 1 : prev - 1));
    }, 500);
    // 等待滑出动作+进入动作完成后
    setTimeout(() => {
      setIsSwitching(false);
    }, 1600);
  };
  const goToNext = () => {
    if (isAnimating) return;
    setIsSwitching(true)
    setIsAnimating(true);
    setNextIndex((prev) => (prev === WearableList.length - 1 ? 0 : prev + 1))
    setTimeout(() => {
      setIsAnimating(false);
    }, 1000);
    setTimeout(() => {
      setCurrentIndex((prev) => (prev === WearableList.length - 1 ? 0 : prev + 1));
    }, 500);
    // 等待滑出动作+进入动作完成后
    setTimeout(() => {
      setIsSwitching(false);
    }, 1600);
  };

  // FCST图片切换
  const [currentIndex1, setCurrentIndex1] = useState(0);
  const [prevIndex, setPrevIndex] = useState(0);
  const [direction, setDirection] = useState('next'); // 用于管理动画进出方向
  const [fcstCoverHovered, setFcstCoverHovered] = useState(false)
  const scrollableRefs = useRef([]);

  useEffect(() => {
    setCurrentIndex1(0)
  }, [isHomeFcstPageActive])

  useEffect(() => {
    setTimeout(() => {
      if (scrollableRefs.current[currentIndex1]) {
        scrollableRefs.current[currentIndex1].scrollTop = 0;
      }
    }, 100);
  }, [currentIndex1])

  const handlePrev = () => {
    if (currentIndex1 > 0) {
      setCurrentIndex1(currentIndex1 - 1);
    }
  };
  const handleNext = () => {
    if (currentIndex1 < FcstList.length - 1) {
      setCurrentIndex1(currentIndex1 + 1);
    }
  };


  // 底部logo滑动
  const containerRef = useRef(null);
  const animationRef = useRef(null);
  const isDraggingRef = useRef(false);
  const startXRef = useRef(0);
  const scrollLeftRef = useRef(0);
  const destinationIndexRef = useRef()
  // 重置滚动位置到起始点
  const resetScrollPosition = () => {
    if (containerRef.current) {
      containerRef.current.scrollLeft = 0;
    }
  };

  const startAutoScroll = () => {
    console.log('起始位置', containerRef.current.scrollLeft)
    const container = containerRef.current;
    if (!container) return;

    const scroll = () => {
      // 如果正在拖拽，则不自动滚动
      if (isDraggingRef.current) {
        animationRef.current = requestAnimationFrame(scroll);
        return;
      }

      container.scrollLeft += 2.5; // 调整这个值可以改变滚动速度

      // 如果滚动到最右边，回到起点
      // if (container.scrollLeft >= container.scrollWidth - container.clientWidth) {
      //   container.scrollLeft = 0;
      // }

      // console.log('destinationIndex', destinationIndexRef.current)
      if (destinationIndexRef.current === 5) {
        animationRef.current = requestAnimationFrame(scroll);
      } else {
        resetScrollPosition(); // 重置到起始位置
      }
    };
    animationRef.current = requestAnimationFrame(scroll);

  };

  // 鼠标事件处理
  const handleMouseDown = (e) => {
    isDraggingRef.current = true;
    startXRef.current = e.pageX - containerRef.current.offsetLeft;
    scrollLeftRef.current = containerRef.current.scrollLeft;

    // 添加样式表示正在拖拽
    containerRef.current.style.cursor = 'grabbing';
    containerRef.current.style.userSelect = 'none';
  };

  const handleMouseLeave = () => {
    isDraggingRef.current = false;
    resetCursor();
  };

  const handleMouseUp = () => {
    isDraggingRef.current = false;
    resetCursor();
  };

  const handleMouseMove = (e) => {
    if (!isDraggingRef.current) return;
    e.preventDefault();

    const x = e.pageX - containerRef.current.offsetLeft;
    const walk = (x - startXRef.current) * 6; // 调整这个乘数可以改变拖拽灵敏度
    containerRef.current.scrollLeft = scrollLeftRef.current - walk;
  };

  const resetCursor = () => {
    if (containerRef.current) {
      containerRef.current.style.cursor = 'grab';
      containerRef.current.style.removeProperty('user-select');
    }
  };


  // 计算高度
  const updateHeight = () => {
    const img = document.querySelector('.Wearable_productImg-img');
    const height = img.offsetHeight || 820
    if (img) {
      const product = document.querySelector('.Wearable_product');
      product.style.height = `${height}px`;
    }
  };
  useEffect(() => {
    updateHeight();
    window.addEventListener('resize', updateHeight);

    // 图片加载事件
    const img = document.querySelector('.Wearable_productImg-img');
    if (img) {
      img.onload = updateHeight;
    }

    return () => {
      window.removeEventListener('resize', updateHeight);
    };
  }, [currentIndex, nextIndex]);

  return (
    <div className="Home">
      <ReactFullpage
        debug={false}
        scrollOverflow={true}
        scrolloverflowmacstyle={false}
        // scrollBar={true}
        // licenseKey="xxxxxxxxxxxxxxxxxxxxxxxxx"
        // anchors={["homeCoverPage", "homeWearablePage", "homePlanPage", "homeNewsPage", "homeFcstPage", "homeAboutPage"]}
        anchors={["homeCoverPage", "homeWearablePage", "homeNewsPage", "homeFcstPage", "homeAboutPage"]}
        onLeave={(origin, destination) => {
          // setIsHomeWearablePageActive(destination.index === 1);
          // setIsHomePlanPageActive(destination.index === 2);
          // setIsHomeNewsPageActive(destination.index === 3);
          // setIsHomeFcstPageActive(destination.index === 4);
          // setIsHomeAboutPageActive(destination.index === 5);
          setIsHomeWearablePageActive(destination.index === 1);
          setIsHomeNewsPageActive(destination.index === 2);
          setIsHomeFcstPageActive(destination.index === 3);
          setIsHomeAboutPageActive(destination.index === 4);
        }}
        afterLoad={(origin, destination, direction) => {
          destinationIndexRef.current = destination.index
          if (destination.index !== 0) {
            setHeaderDark(true)
          } else {
            setHeaderDark(false)
          }
          if (destination.index === 5) {
            console.log('进入页面重置');
            // 等待动画完成后开始自动滚动
            const imgContainer = document.querySelector('.AboutUs_Bottom');
            // 添加过渡结束事件监听
            const handleTransitionEnd = () => {
              startAutoScroll();
              imgContainer.removeEventListener('transitionend', handleTransitionEnd);
            };

            imgContainer.addEventListener('transitionend', handleTransitionEnd);
          }
        }}
        render={({ state, fullpageApi }) => {
          const handleWearableClick = () => {
            fullpageApi.moveTo('homeWearablePage');
          };
          const handleTherapeuticClick = () => {
            // fullpageApi.moveTo('homePlanPage');
          };
          return (
            <ReactFullpage.Wrapper>
              {/* 标题页 */}
              <div className="section">
                <div className='App_cover-content flex_center ta_c c_ff pageMargin'>
                  <div className="App_cover-title of_hidden">
                    {/* <div className='App_cover-titleText'>世界领先的<br />脑科学机制研究驱动的眼科诊疗平台</div> */}
                    <div className='App_cover-titleText'>脑科学机制研究驱动的眼科诊疗平台</div>
                  </div>
                  <div className='App_cover-subTitle of_hidden mt_10'>
                    {/* <div className='App_cover-subTitleText'>The world's leading brain science mechanism research driven ophthalmic treatment platform</div> */}
                    <div className='App_cover-subTitleText'>Brain Science-Driven Ophthalmology Platform</div>
                  </div>
                  <div className='App_cover-tab gap_16 mt_43'>
                    <div className='App_cover-tabItem flex_col flex_ai-c cur_p' onClick={handleWearableClick}>
                      <img
                        className='App_cover-tabImage'
                        src='./images/home/ARglasses_icon.png'
                        alt=''
                      />
                      <div className='App_cover-tabPc'>
                        <div className='fz_20 fw_500 lh_24 mt_10'>集视穿戴产品</div>
                        <div className='fz_16 fw_500 lh_18 mt_8 ml_10 mr_10 pb_20'>Focusight® Wearable products</div>
                      </div>
                      <div className='App_cover-tabMobile'>
                        <div className='fz_16 fw_500 lh_18 mt_2'>集视穿戴产品</div>
                        <div className='fz_12 fw_500 lh_14 mt_4 ml_10 mr_10 pb_14'>Focusight® Wearable products</div>
                      </div>
                    </div>
                    <div className='App_cover-tabItem flex_col flex_ai-c cur_p' onClick={handleTherapeuticClick}>
                      <img
                        className='App_cover-tabImage'
                        src='./images/home/eyes_icon.png'
                        alt=''
                      />
                      <div className='App_cover-tabPc'>
                        {/* <div className='fz_20 fw_500 lh_24 mt_10'>集视治疗方案</div> */}
                        {/* <div className='fz_16 fw_500 lh_18 mt_8 ml_10 mr_10 pb_20'>Focusight® Therapeutic regimen</div> */}
                        <div className='fz_20 fw_500 lh_24 mt_10'>集视干预方案</div>
                        <div className='fz_16 fw_500 lh_18 mt_8 ml_10 mr_10 pb_20'>Focusight® Intervention plan</div>
                      </div>
                      <div className='App_cover-tabMobile'>
                        {/* <div className='fz_16 fw_500 lh_18 mt_2'>集视治疗方案</div> */}
                        {/* <div className='fz_12 fw_500 lh_14 mt_4 ml_10 mr_10 pb_14'>Focusight® Therapeutic regimen</div> */}
                        <div className='fz_16 fw_500 lh_18 mt_2'>集视干预方案</div>
                        <div className='fz_12 fw_500 lh_14 mt_4 ml_10 mr_10 pb_14'>Focusight® Intervention plan</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* 集视穿戴产品 */}
              <div className="section">
                <div className='Wearable'>
                  <div style={{ position: 'relative', zIndex: 10 }}>
                    <div className='pageMargin'>
                      {/* PC端 */}
                      <div className={`Wearable_top-pc flex_row flex_jc-sb pt_140 ${isHomeWearablePageActive ? 'active' : ''}`}>
                        <div className='fz_32 fw_700 lh_38 linear-gradient-tr'>集视穿戴产品</div>
                        <div className='fz_20 fw_500 lh_24 linear-gradient-tr'>Focusight®<br />Wearable products</div>
                        <div className='fz_16 fw_500 lh_24 c_85899E'>集视医疗致力于融合底层脑科学+眼病机制研究+可穿戴智能化产品，<br />有效改善了传统弱视干预手段在年龄、效果、治疗场景、患者依从性等方面的局限。</div>
                      </div>
                      {/* 移动端 */}
                      <div className={`Wearable_top-mobile flex_row flex_jc-sb pt_100 ${isHomeWearablePageActive ? 'active' : ''}`}>
                        <div>
                          <div className='fz_18 fw_700 lh_21 linear-gradient-tr'>集视穿戴产品</div>
                          <div className='fz_14 fw_500 lh_16 mt_6 linear-gradient-tr'>Focusight®<br />Wearable products</div>
                        </div>
                        <div
                          className='Wearable_product-mobileBtn flex_row flex_jc-c flex_ai-c'
                          onMouseEnter={() => setHovered(true)}
                          onMouseLeave={() => setHovered(false)}
                          onClick={(() => navigate('/productsIndex#argosPage'))}
                        >
                          <div>探索更多</div>
                          <img
                            className='Wearable_product-rightArrowMobile'
                            src={hovered ? './images/home/arrow-right-whiteLine.png' : './images/home/arrow-right-blackLine.png'}
                            alt=''
                          />
                        </div>
                      </div>
                    </div>
                    <div className='Wearable_product c_23253B mt_80 flex_row flex_jc-sb'>
                      <div className='flex_col flex_jc-sb'>
                        <div style={{ flex: 1 }}></div>
                        <div
                          className={`Wearable_product-top ${isHomeWearablePageActive ? 'active' : ''} ${isAnimating ? 'slide-out-left' : ''}`}
                          style={{ flex: 1, transitionDelay: isSwitching ? '' : '1s' }}
                        >
                          <div className="fz_40 fw_900 lh_47">{WearableList[currentIndex].title}</div>
                          <div className="fz_20 fw_500 lh_24 mt_2">{WearableList[currentIndex].subTitle}</div>
                          <div
                            className='Wearable_product-btn flex_row flex_jc-c flex_ai-c'
                            onMouseEnter={() => setHovered(true)}
                            onMouseLeave={() => setHovered(false)}
                            onClick={(() => navigate(WearableList[currentIndex].route))}
                          >
                            <div>了解产品</div>
                            <img
                              className='Wearable_product-rightArrow'
                              src={hovered ? './images/home/arrow-right-whiteLine.png' : './images/home/arrow-right-blackLine.png'}
                              alt=''
                            />
                          </div>
                        </div>
                        <div className='Wearable_product-bottom flex_row flex_ai-fe' style={{ flex: 1 }}>
                          <div className={`Wearable_product-slider ${isHomeWearablePageActive ? 'active' : ''}`}>
                            <div
                              className='Wearable_product-sliderBtn'
                              onClick={goToPrev}
                              onMouseEnter={() => setLeftBtnHovered(true)}
                              onMouseLeave={() => setLeftBtnHovered(false)}
                            >
                              <img
                                className='Wearable_product-sliderBtnIcon'
                                src={leftBtnHovered ? './images/home/whiteLeftIcon.png' : './images/home/blackLeftIcon.png'}
                                alt=''
                              />
                            </div>
                            <div className='flex_row flex_ai-c'>
                              {WearableList.map((_, index) => (
                                <div
                                  key={index}
                                  className={`Wearable_product-indicator ${index === currentIndex ? 'active' : ''}`}
                                />
                              ))}
                            </div>
                            <div
                              className='Wearable_product-sliderBtn'
                              onClick={goToNext}
                              onMouseEnter={() => setRightBtnHovered(true)}
                              onMouseLeave={() => setRightBtnHovered(false)}
                            >
                              <img
                                className='Wearable_product-sliderBtnIcon'
                                src={rightBtnHovered ? './images/home/whiteRightIcon.png' : './images/home/blackRightIcon.png'}
                                alt=''
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className={`Wearable_productImg flex_row flex_ai-c flex_jc-fe ${isHomeWearablePageActive ? 'active' : ''}`}>
                        <img
                          className={`Wearable_productImg-img ${isAnimating ? 'slide-out' : ''}`}
                          src={WearableList[currentIndex].img}
                          alt=''
                        />
                        {WearableList[nextIndex].img && isAnimating && (<img
                          className={`Wearable_productImg-img slide-in`}
                          src={WearableList[nextIndex].img}
                          alt=''
                        />)}
                      </div>
                    </div>
                    <div className='pageMargin'>
                      <div className="Wearable_bottom mt_40 pb_40">
                        {WearableList.map((item) => <div
                          className={`Wearable_bottom-item flex_col flex_jc-sb ${isHomeWearablePageActive ? 'active' : ''}`}
                        >
                          <img
                            src={item.miniImg}
                            alt=''
                          />
                          <div className='Wearable_bottom-itemBlock flex_row flex_jc-sb'>
                            <div>
                              <div className='Wearable_bottom-itemTitle'>{item.title}</div>
                              <div className='Wearable_bottom-itemSubTitle'>{item.subTitle}</div>
                            </div>
                            <div
                              className='Wearable_product-btn flex_center'
                              onClick={(() => navigate(item.route))}
                            >
                              探索产品
                            </div>
                          </div>
                        </div>)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* 集视在研方案 */}
              {/* <div className="section">
                <div className='pageMargin'>
                  PC端
                  <div className={`TreatmentPlan_topPc mt_140 flex_row flex_jc-sb ${isHomePlanPageActive ? 'active' : ''}`}>
                    <div className='fz_32 fw_700 lh_38 linear-gradient-tr'>集视在研方案</div>
                    <div
                      className='TreatmentPlan_top-btn'
                      onMouseEnter={() => setHovered(true)}
                      onMouseLeave={() => setHovered(false)}
                    >
                      <Link
                        to='/productsIndex'
                        onClick={() => {
                          document.scrollingElement.scrollTop = 0
                        }}
                      >
                        探索更多
                        <img
                          className='Wearable_product-rightArrow'
                          src={hovered ? './images/home/arrow-right-whiteLine.png' : './images/home/arrow-right-blackLine.png'}
                          alt=''
                        />
                      </Link>
                    </div>
                    <div>
                      <div className='fz_20 fw_500 lh_24 linear-gradient-tr' style={{ width: 142 }}>Focusight®<br />Treatment plan</div>
                      <div className='fz_16 fw_500 lh_24 c_23253B mt_10'>集视医疗致力于融合底层脑科学+眼病机制研究+可穿戴智能化产品，<br />有效改善了传统弱视干预手段在年龄、效果、治疗场景、患者依从性等方面的局限。</div>
                    </div>
                  </div>
                  移动端
                  <div className={`TreatmentPlan_topMobile mt_100 flex_row flex_jc-sb ${isHomePlanPageActive ? 'active' : ''}`}>
                    <div>
                      <div className='fz_18 fw_700 lh_21'>集视在研方案</div>
                      <div className='fz_14 fw_500 lh_16 mt_6'>Focusight®<br />Treatment plan</div>
                    </div>
                    <div
                      className='Wearable_product-mobileBtn flex_row flex_jc-c flex_ai-c'
                      onMouseEnter={() => setHovered(true)}
                      onMouseLeave={() => setHovered(false)}
                      onClick={(() => navigate('/productsIndex#planPage'))}
                    >
                      <div>探索更多</div>
                      <img
                        className='Wearable_product-rightArrowMobile'
                        src={hovered ? './images/home/arrow-right-whiteLine.png' : './images/home/arrow-right-blackLine.png'}
                        alt=''
                      />
                    </div>
                  </div>
                  <div className={`TreatmentPlan_content ${isHomePlanPageActive ? 'active' : ''}`}>
                    {TreatmentPlanList.map((item) => <div
                      className="TreatmentPlan_contentItem flex_row flex_ai-c"
                    >
                      <img
                        src={item.img}
                        alt=''
                      />
                      <div className='TreatmentPlan_contentItemBlock flex_col flex_jc-sb'>
                        <div>
                          <div className="TreatmentPlan_itemTitle ellipsis">{item.title}</div>
                          <div className="TreatmentPlan_itemSubTitle multiline-ellipsis-2">{item.desc}</div>
                        </div>
                        <div
                          className='Plan_bottom-btn flex_center '
                          onClick={(() => navigate(item.route))}
                        >
                          了解方案
                        </div>
                      </div>
                    </div>)}
                  </div>
                </div>
              </div> */}
              {/* 公司动态 */}
              <div className="section">
                <div className='pageMargin'>
                  {/* PC端 */}
                  <div className={`TreatmentPlan_topPc mt_140 flex_row flex_jc-sb ${isHomeNewsPageActive ? 'active' : ''}`}>
                    <div className='fz_32 fw_700 lh_38 c_23253B'>公司动态</div>
                    <div
                      className='TreatmentPlan_top-btn'
                      onMouseEnter={() => setHovered(true)}
                      onMouseLeave={() => setHovered(false)}
                    >
                      <Link
                        to='/companyNews'
                        onClick={() => {
                          document.scrollingElement.scrollTop = 0
                        }}
                      >
                        全部资讯
                        <img
                          className='Wearable_product-rightArrow'
                          src={hovered ? './images/home/arrow-right-whiteLine.png' : './images/home/arrow-right-blackLine.png'}
                          alt=''
                        />
                      </Link>
                    </div>
                    <div>
                      <div className='fz_20 fw_500 lh_24 c_23253B'>Focusight®<br />News information</div>
                      <div className='fz_16 fw_500 lh_24 c_23253B mt_10'>集视医疗最新资讯，及时了解近期最新活动。</div>
                    </div>
                  </div>
                  {/* 移动端 */}
                  <div className={`TreatmentPlan_topMobile mt_100 flex_row flex_jc-sb ${isHomeNewsPageActive ? 'active' : ''}`}>
                    <div>
                      <div className='fz_18 fw_700 lh_21'>公司动态</div>
                      <div className='fz_14 fw_500 lh_16 mt_6'>Focusight®<br />News information</div>
                    </div>
                    <div
                      className='Wearable_product-mobileBtn flex_row flex_jc-c flex_ai-c'
                      onMouseEnter={() => setHovered(true)}
                      onMouseLeave={() => setHovered(false)}
                      onClick={(() => navigate('/companyNews'))}
                    >
                      <div>全部资讯</div>
                      <img
                        className='Wearable_product-rightArrowMobile'
                        src={hovered ? './images/home/arrow-right-whiteLine.png' : './images/home/arrow-right-blackLine.png'}
                        alt=''
                      />
                    </div>
                  </div>
                  <div className="News_content">
                    <div className="News_content-left">
                      {NewsList.map((item, index) => <div
                        className={`News_content-leftItem ${isHomeNewsPageActive ? 'active' : ''}`}
                        onClick={(() => navigate(item.route))}
                      >
                        <div className='flex_row gap_10 cur_p'>
                          <div className='News_content-itemNum fz_60 fw_700 lh_70 c_85899E flex_row flex_ai-c'>0{index + 1}</div>
                          <div className='News_content-itemBlock'>
                            <div className="News_content-itemDate">{item.date}</div>
                            <div className="News_content-itemTitle ellipsis">{item.title}</div>
                            <div className="News_content-itemDesc multiline-ellipsis">{item.desc}</div>
                          </div>
                        </div>
                        <div className='News_content-itemLine'></div>
                      </div>)}
                    </div>
                    <div className={`News_content-Right flex_row flex_jc-c ${isHomeNewsPageActive ? 'active' : ''}`}>
                      <img
                        src='/images/home/companyNews.png'
                        alt=''
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/* FCST研究院 */}
              <div className="section">
                <div className='pageMargin'>
                  {/* PC端 */}
                  <div className={`TreatmentPlan_topPc mt_140 flex_row flex_jc-sb ${isHomeFcstPageActive ? 'active' : ''}`}>
                    <div className='fz_32 fw_700 lh_38 c_23253B'>FCST研究院</div>
                    <div className='Fcst_top-btn'>
                      <Link
                        to='/fcst'
                        onClick={() => {
                          document.scrollingElement.scrollTop = 0
                        }}
                      >
                        全部进展
                        <img
                          className='Wearable_product-rightArrow'
                          src='./images/home/arrow-right-whiteLine.png'
                          alt=''
                        />
                      </Link>
                    </div>
                    <div>
                      <div className='fz_20 fw_500 lh_24 c_23253B'>Focusight®<br />Research institute</div>
                      <div className='fz_16 fw_500 lh_24 c_23253B mt_10'>集视医疗全球高技术研发团队，在理论和方法均有突破，<br />及时了解我们的最新项目进度和产品研发事项。</div>
                    </div>
                  </div>
                  {/* 移动端 */}
                  <div className={`TreatmentPlan_topMobile mt_100 flex_row flex_jc-sb ${isHomeFcstPageActive ? 'active' : ''}`}>
                    <div>
                      <div className='fz_18 fw_700 lh_21'>FCST研究院</div>
                      <div className='fz_14 fw_500 lh_16 mt_6'>Focusight®<br />Research institute</div>
                    </div>
                    <div className='Fcst_top-btn'>
                      <Link
                        to='/fcst'
                        onClick={() => {
                          document.scrollingElement.scrollTop = 0
                        }}
                      >
                        <div>全部进展</div>
                        <img
                          className='Wearable_product-rightArrowMobile'
                          src='./images/home/arrow-right-whiteLine.png'
                          alt=''
                        />
                      </Link>
                    </div>
                  </div>
                  <div className={`Fcst_all ${isHomeFcstPageActive ? 'active' : ''}`}>
                    <div className="of_hidden">
                      {/* PC端 */}
                      <div className="Fcst_contentPc flex_row flex_jc-sb flex_ai-c gap_16">
                        <div
                          className={`Fcst_content-sliderBtn flex_auto ${currentIndex1 === 0 ? 'disabled' : ''}`}
                          onClick={() => {
                            if (currentIndex1 !== 0) {
                              setPrevIndex(currentIndex1);
                              setCurrentIndex1(currentIndex1 - 1)
                              setDirection('prev');
                            }
                          }}
                        >
                          <img
                            className='Wearable_product-sliderBtnIcon'
                            src='./images/home/whiteLeftIcon.png'
                            alt=''
                          />
                        </div>
                        <div className="flex_full flex_row of_hidden" >
                          {FcstList.map((item, index) =>
                            <div
                              key={index}
                              className={`Fcst_content-block ${index === currentIndex1
                                ? direction === 'next'
                                  ? 'slide-in-next'
                                  : 'slide-in-prev'
                                : index === prevIndex
                                  ? direction === 'next'
                                    ? 'slide-out-next'
                                    : 'slide-out-prev'
                                  : ''
                                }`}
                              style={{ display: index === currentIndex1 ? '' : 'none' }}
                            >
                              <div className="Fcst_cover-contentImg flex_row flex_ai-c flex_jc-c">
                                <img
                                  style={{ width: '100%' }}
                                  src={item.img}
                                  alt=''
                                />
                              </div>
                              <div className="Fcst_cover-contentRight">
                                <div className="Fcst_cover-contentRightBlock">
                                  <div className="of_hidden FcstScollbar" style={{ height: '100%', overflowY: 'auto' }} ref={(el) => scrollableRefs.current[index] = el}>
                                    <div
                                      style={{ height: '100%' }}
                                      className={`
                                      flex_col flex_jc-sb gap_10
                                      ${currentIndex1 === 0 ? 'Fcst_contentRight-item' : ''}
                                      ${isHomeFcstPageActive && currentIndex1 === 0 ? 'active' : ''}`
                                      }
                                    >
                                      <div className="fz_18 fw_500 lh_21">{item.date}</div>
                                      <div>
                                        <div className="fz_32 fw_700 lh_38">{item.title}</div>
                                        <div className="fz_16 fw_500 lh_24 multiline-ellipsis" style={{ marginTop: '5%' }}>{item.desc}</div>
                                      </div>
                                      <div
                                        className='Fcst_cover-btn flex_row flex_jc-c flex_ai-c'
                                        onClick={() => navigate(item.route)}
                                        onMouseEnter={() => setFcstCoverHovered(true)}
                                        onMouseLeave={() => setFcstCoverHovered(false)}
                                      >
                                        <div>阅读文章</div>
                                        <img
                                          className='Wearable_product-rightArrow'
                                          src={fcstCoverHovered ? './images/home/arrow-right-blackLine.png' : './images/home/arrow-right-whiteLine.png'}
                                          alt=''
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>)}
                        </div>
                        <div
                          className={`Fcst_content-sliderBtn flex_auto ${currentIndex1 === FcstList.length - 1 ? 'disabled' : ''}`}
                          onClick={() => {
                            if (currentIndex1 !== FcstList.length - 1) {
                              setPrevIndex(currentIndex1);
                              setCurrentIndex1(currentIndex1 + 1)
                              setDirection('next');
                            }
                          }}
                        >
                          <img
                            className='Wearable_product-sliderBtnIcon'
                            src='./images/home/whiteRightIcon.png'
                            alt=''
                          />
                        </div>
                      </div>
                      {/* Swiper组件 */}
                      {/* <div className="Fcst_contentPc flex_row flex_ai-c gap_20">
                        <div
                          className={`Fcst_cover-swiperButtonPrev mb_60 flex_center ${currentIndex1 === 0 ? 'disabled' : ''}`}
                          onClick={handlePrev}
                        >
                          <img
                            className='Wearable_product-sliderBtnIcon'
                            src='./images/home/whiteLeftIcon.png'
                            alt=''
                          />
                        </div>
                        <Swiper
                          className='HomeFcst_cover-swiper'
                          style={{ width: 'calc(100% - 180px)' }}
                          pagination={true}
                          navigation={{
                            nextEl: '.Fcst_cover-swiperButtonNext',
                            prevEl: '.Fcst_cover-swiperButtonPrev',
                          }}
                          modules={[Navigation, Pagination]}
                        >
                          {FcstList.map((item, index) => <SwiperSlide key={index} className='flex_row flex_jc-c'>
                            <div className='flex_row flex_jc-sb gap_16'>
                              <div className="Fcst_cover-contentImg flex_center">
                                <img
                                  style={{ width: '100%' }}
                                  src={item.img}
                                  alt=''
                                />
                              </div>
                              <div className="Fcst_cover-contentRight">
                                <div className="Fcst_cover-contentRightBlock">
                                  <div className="of_hidden" style={{ height: '100%' }}>
                                    <div
                                      style={{ height: '100%' }}
                                      className={`
                                      flex_col flex_jc-sb gap_10
                                      ${currentIndex1 === 0 ? 'Fcst_contentRight-item' : ''}
                                      ${isHomeFcstPageActive && currentIndex1 === 0 ? 'active' : ''}`
                                      }
                                    >
                                      <div className="fz_18 fw_500 lh_21">{item.date}</div>
                                      <div>
                                        <div className="fz_32 fw_700 lh_38 ellipsis">{item.title}</div>
                                        <div className="fz_16 fw_500 lh_24 multiline-ellipsis" style={{ marginTop: '5%' }}>{item.desc}</div>
                                      </div>
                                      <div
                                        className='Fcst_cover-btn flex_row flex_jc-c flex_ai-c'
                                        onClick={() => navigate(item.route)}
                                        onMouseEnter={() => setFcstCoverHovered(true)}
                                        onMouseLeave={() => setFcstCoverHovered(false)}
                                      >
                                        <div>阅读文章</div>
                                        <img
                                          className='Wearable_product-rightArrow'
                                          src={fcstCoverHovered ? './images/home/arrow-right-blackLine.png' : './images/home/arrow-right-whiteLine.png'}
                                          alt=''
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </SwiperSlide>)}
                        </Swiper>
                        <div
                          className={`Fcst_cover-swiperButtonNext mb_60 flex_center ${currentIndex1 >= FcstList.length - 1 ? 'disabled' : ''}`}
                          onClick={handleNext}
                        >
                          <img
                            className='Wearable_product-sliderBtnIcon'
                            src='./images/home/whiteRightIcon.png'
                            alt=''
                          />
                        </div>
                      </div> */}
                      {/* 移动端 */}
                      <div className="Fcst_contentMobile">
                        <Swiper
                          className='HomeFcst_cover-swiper'
                          pagination={true}
                          modules={[Pagination]}
                        >
                          {FcstList.map((item, index) => <SwiperSlide key={index}>
                            <div
                              className='flex_col flex_jc-sb gap_12'
                              style={{ width: '100%' }}
                            >
                              <div className="Fcst_cover-contentImg flex_center">
                                <img
                                  style={{ width: '100%' }}
                                  src={item.img}
                                  alt=''
                                />
                              </div>
                              <div className="Fcst_cover-contentRight">
                                <div className="Fcst_cover-contentRightBlock">
                                  <div className="of_hidden" style={{ height: '100%' }}>
                                    <div
                                      style={{ height: '100%' }}
                                      className={`
                                      flex_col flex_jc-sb gap_10
                                      ${currentIndex1 === 0 ? 'Fcst_contentRight-item' : ''}
                                      ${isHomeFcstPageActive && currentIndex1 === 0 ? 'active' : ''}`
                                      }
                                    >
                                      <div className="fz_12 fw_500 lh_14">{item.date}</div>
                                      <div>
                                        <div className="fz_18 fw_700 lh_21">{item.title}</div>
                                        <div className="fz_12 fw_500 lh_16 mt_10">{item.desc}</div>
                                      </div>
                                      <div
                                        className='Fcst_cover-btn flex_row flex_jc-c flex_ai-c'
                                        onClick={() => navigate(item.route)}
                                        onMouseEnter={() => setFcstCoverHovered(true)}
                                        onMouseLeave={() => setFcstCoverHovered(false)}
                                      >
                                        <div>阅读文章</div>
                                        <img
                                          className='Wearable_product-rightArrowMobile'
                                          src={fcstCoverHovered ? './images/home/arrow-right-blackLine.png' : './images/home/arrow-right-whiteLine.png'}
                                          alt=''
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </SwiperSlide>)}
                        </Swiper>
                      </div>
                    </div>
                    {/* PC端分页 */}
                    <div className="Fcst_bottom">
                      {FcstList.map((_, index) => (
                        <div
                          key={index}
                          className={`Fcst_bottom-indicator ${index === currentIndex1 ? 'active' : ''}`}
                        />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              {/* 关于我们 */}
              <div className="section">
                <div>
                  <div className='pageMargin'>
                    {/* PC端 */}
                    <div className='AboutUs_topPc flex_row flex_jc-sb mt_140 of_hidden'>
                      <div className={`AboutUs_title fz_60 fw_700 lh_70 c_23253B text ${isHomeAboutPageActive ? 'active' : ''}`}>FOCUSIGHT<br />集视医疗®</div>
                      <div className='of_hidden'>
                        <div
                          className={`AboutUs_top-btn flex_row flex_jc-c flex_ai-c cur_p ${isHomeAboutPageActive ? 'active' : ''}`}
                          onMouseEnter={() => setHovered(true)}
                          onMouseLeave={() => setHovered(false)}
                          onClick={(() => navigate('/aboutUs'))}
                        >
                          <div>详细了解</div>
                          <img
                            className='Wearable_product-rightArrow'
                            src={hovered ? './images/home/arrow-right-whiteLine.png' : './images/home/arrow-right-blackLine.png'}
                            alt=''
                          />
                        </div>
                      </div>
                      <div className='AboutUs_desc'>
                        <div className={`AboutUs_desc-text ${isHomeAboutPageActive ? 'active' : ''}`}>
                          集视医疗是一家专注于眼科医疗器械的创新型企业。致力于从底层脑科学+眼病机制研究+可穿戴智能化产品，有效改善了传统弱视干预手段在年龄、效果、治疗场景、患者依从性等方面的局限，提高眼病患者干预效果及可及性。
                          <br />
                          <br />
                          {/* 公司以脑科学研究为基础载体运用领先的物联网、人工智能与大数据云计算技术，打通院内外及患者全时空全病程数据，全面赋能眼科疾病的诊断、治疗及诊后管理。 */}
                          公司以脑科学研究为基础载体运用物联网、人工智能与大数据云计算技术，打通院内外及患者全时空全病程数据，全面赋能眼科疾病的诊断、治疗及诊后管理。
                        </div>
                      </div>
                    </div>
                    {/* 移动端 */}
                    <div className='AboutUs_topMobile mt_100 of_hidden'>
                      <div className='flex_row flex_jc-sb'>
                        <div className={`AboutUs_title text ${isHomeAboutPageActive ? 'active' : ''}`}>FOCUSIGHT<br />集视医疗®</div>
                        <div className='of_hidden'>
                          <div
                            className='Wearable_product-mobileBtn flex_row flex_jc-c flex_ai-c'
                            onMouseEnter={() => setHovered(true)}
                            onMouseLeave={() => setHovered(false)}
                            onClick={(() => navigate('/aboutUs'))}
                          >
                            <div>详细了解</div>
                            <img
                              className='Wearable_product-rightArrowMobile'
                              src={hovered ? './images/home/arrow-right-whiteLine.png' : './images/home/arrow-right-blackLine.png'}
                              alt=''
                            />
                          </div>
                        </div>
                      </div>
                      <div className='AboutUs_desc'>
                        <div className={`AboutUs_desc-text ${isHomeAboutPageActive ? 'active' : ''}`}>
                          集视医疗是一家专注于眼科医疗器械的创新型企业。致力于从底层脑科学+眼病机制研究+可穿戴智能化产品，有效改善了传统弱视干预手段在年龄、效果、治疗场景、患者依从性等方面的局限，提高眼病患者干预效果及可及性。
                          <br />
                          <br />
                          {/* 公司以脑科学研究为基础载体运用领先的物联网、人工智能与大数据云计算技术，打通院内外及患者全时空全病程数据，全面赋能眼科疾病的诊断、治疗及诊后管理。 */}
                          公司以脑科学研究为基础载体运用物联网、人工智能与大数据云计算技术，打通院内外及患者全时空全病程数据，全面赋能眼科疾病的诊断、治疗及诊后管理。
                        </div>
                      </div>
                    </div>
                    <div className="AboutUs_content-block">
                      {teamList.map((item) => <div className={`AboutUs_content-item ${isHomeAboutPageActive ? 'active' : ''}`}>
                        <div className='AboutUs_content-itemBlock flex_col flex_ai-c'>
                          <img
                            className='AboutUs_content-itemIcon'
                            src={item.icon}
                            alt=''
                          />
                          <div className="AboutUs_content-itemName">{item.name}</div>
                          {item.member.map((i) => <div className='AboutUs_content-itemMember'>
                            {i}
                          </div>)}
                        </div>
                        <div className="AboutUs_content-itemDesc">{item.desc}</div>
                      </div>)}
                    </div>
                  </div>
                  <div
                    className={`AboutUs_Bottom ${isHomeAboutPageActive ? 'active' : ''}`}
                    ref={containerRef}
                    onMouseDown={handleMouseDown}
                    onMouseLeave={handleMouseLeave}
                    onMouseUp={handleMouseUp}
                    onMouseMove={handleMouseMove}
                    style={{ cursor: 'grab' }}
                  >
                    {cooperate.map((i, index) => (
                      <div key={index} className="AboutUs_Bottom-container">
                        <img
                          src={i}
                          alt=''
                          className="scroll-image"
                          draggable="false" // 防止图片被拖拽
                        />
                      </div>
                    ))}
                  </div>
                </div>
                <Footer />
              </div>

            </ReactFullpage.Wrapper>
          )
        }}
      />
    </div>
  );
}

export default Home;